// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"793383de","666":"77607b98","765":"c5b43a11","881":"f5181c80","993":"5e7ea183"}[chunkId] + ".chunk.js";
};